export default "__VITE_ASSET__d9c7dc81__"